
import { NgModule,ErrorHandler } from '@angular/core';


import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { ErrorsHandler } from './errors-handler';

//Firebase
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule  } from '@angular/fire/firestore';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireMessagingModule } from '@angular/fire/messaging';


//Paginas
import { PagesModule } from './pages/pages.module';
//Shared
import {SharedModule} from './shared.module';
//Components
import { ComponentsModule } from './components/components.module';


//SetBrasilLocale
import { registerLocaleData } from '@angular/common';
import localePr from '@angular/common/locales/pt';
// the second parameter 'pt' is optional
registerLocaleData(localePr, 'pt');
	

@NgModule({
	declarations: [
		AppComponent,
	],
  imports: [
    PagesModule,
    ComponentsModule,
    ServiceWorkerModule.register('/ngsw-worker.js', { enabled: environment.production }),
	AngularFireModule.initializeApp(environment.firebase),
	AngularFireAuthModule,
    AngularFirestoreModule.enablePersistence(),
	AngularFireStorageModule,
	AngularFireMessagingModule,
    SharedModule
  ],
  providers: [
	    {provide: ErrorHandler,useClass: ErrorsHandler}
  ],
  bootstrap: [AppComponent]
})
export class AppModule{}